import type { Filters } from '@cognite/fdm-client';
import type { DirectRelationReference } from '@cognite/sdk';

/**
 * Creates a direct relation filter for root location with the specified external IDs.
 * Used for filtering data based on root asset locations in CDM.
 */
export const createRootLocationFilter = (
  rootLocation: DirectRelationReference | undefined
): Filters | undefined => {
  if (!rootLocation) {
    return undefined;
  }

  return {
    directRelationFilter: {
      rootLocation: {
        equals: {
          property: 'externalId',
          eq: rootLocation.externalId,
        },
      },
    },
    directRelationInstanceSpace: rootLocation.space,
  };
};
